import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
const Grid = function Grid(props) {
    const { prefixCls: customizePrefixCls, className, ...others } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const classString = classNames(`${prefixCls}-grid`, className);
    return React.createElement("div", Object.assign({}, others, { className: classString }));
};
Grid.displayName = 'CardGrid';
export default Grid;
